'use strict';
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002emodifiers$002e$002dModifier from "./com.raquo.laminar.modifiers.-Modifier.js";
import * as $j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024 from "./com.raquo.laminar.tags.-Custom-Html-Tag$.js";
import * as $j_io$002egithub$002enguyenyou$002ewebawesome$002elaminar$002e$002dWeb$002dComponent$0024to$002dL$0024 from "./io.github.nguyenyou.webawesome.laminar.-Web-Component$to-L$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
var $p;
function $ct_Lio_github_nguyenyou_webawesome_laminar_WebComponent__T__($thiz, tagName) {
  $thiz.jN = tagName;
  $thiz.cQ();
  return $thiz;
}
export { $ct_Lio_github_nguyenyou_webawesome_laminar_WebComponent__T__ as $ct_Lio_github_nguyenyou_webawesome_laminar_WebComponent__T__ };
/** @constructor */
function $c_Lio_github_nguyenyou_webawesome_laminar_WebComponent() {
  this.jN = null;
  this.jM = null;
  this.jO = false;
  this.jP = null;
  this.jQ = false;
}
export { $c_Lio_github_nguyenyou_webawesome_laminar_WebComponent as $c_Lio_github_nguyenyou_webawesome_laminar_WebComponent };
$p = $c_Lio_github_nguyenyou_webawesome_laminar_WebComponent.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lio_github_nguyenyou_webawesome_laminar_WebComponent;
/** @constructor */
function $h_Lio_github_nguyenyou_webawesome_laminar_WebComponent() {
}
export { $h_Lio_github_nguyenyou_webawesome_laminar_WebComponent as $h_Lio_github_nguyenyou_webawesome_laminar_WebComponent };
$h_Lio_github_nguyenyou_webawesome_laminar_WebComponent.prototype = $p;
$p.ec = (function() {
  if ((!this.jO)) {
    this.jM = new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_tags_CustomHtmlTag(this.jN, $j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024.$m_Lcom_raquo_laminar_tags_CustomHtmlTag$().eO(), ($j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024.$m_Lcom_raquo_laminar_tags_CustomHtmlTag$(), (void 0)));
    this.jO = true;
  }
  return this.jM;
});
$p.aP = (function(componentMods, laminarMods) {
  var el = this.ec().u($j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aC(new ($j_com$002eraquo$002elaminar$002emodifiers$002e$002dModifier.$d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([])));
  componentMods.a6(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => {
    _$1.j(this).dL(el);
  })));
  laminarMods.a6(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$2) => {
    _$2.dL(el);
  })));
  return el;
});
$p.Y9 = (function() {
  if ((!this.jQ)) {
    this.jP = new $j_io$002egithub$002enguyenyou$002ewebawesome$002elaminar$002e$002dWeb$002dComponent$0024to$002dL$0024.$c_Lio_github_nguyenyou_webawesome_laminar_WebComponent$toL$();
    this.jQ = true;
  }
  return this.jP;
});
